import React, { Fragment, useState, useEffect, useContext } from "react";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, P, Image } from "../AbstractElements";
import { EmailAddress, Password, SignIn } from "../Constant";

import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import { requestForToken } from "../firebase";
import axiosInstance, { axiosNAKBHOInstance } from "../interceptor/intercetptor-inctence";
// import Loader from "../Layout/Loader";
import logoLight from '../../src/assets/images/login/logo_white.png';
import logoDark from '../../src/assets/images/login/logo_dark.png';
import assets5 from '../../src/assets/images/login/Asset-5.png';
import coatOfArms from '../../src/assets/images/login/Coat_of_arms_of_Zimbabwe.png';
import { useTranslation } from "react-i18next";
import { useClinicAdmin } from "../_helper/ClinicProvider";
import PrivilegeContext from "../_helper/PrivilegeContext";
import { useLoader } from "../_helper/LoaderContext";
import { secureApiRequest } from "../Services/secureApiRequest";
import { decryptResponseData } from "../Services/decryptApiResponse";
import { usePharmacy } from "../_helper/PharmacyProvider";
import { useLicense } from "../_helper/license/LicenseContext";

const Signin = ({ selected }) => {
	const { t } = useTranslation();
	const {
		saveLicenseToken,
		decodeTokenOnly,
		doesLicenseBelongToUser,
		decodeJWT
	} = useLicense();
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [emailError, setEmailError] = useState("");
	const [passwordError, setPasswordError] = useState("");
	const [togglePassword, setTogglePassword] = useState(false);
	const history = useNavigate();
	const [token, setToken] = useState('');
	const { setLoading } = useLoader();
	const { clinicAdmin, setClinicAdmin } = useClinicAdmin();
	const { setPharmacyPOS } = usePharmacy();
	const { setUserPrivileges } = useContext(PrivilegeContext);
	const user = localStorage.getItem('currentPharmacyPOS')

	useEffect(() => {
		if (user) history(`${process.env.PUBLIC_URL}/dashboard`);
		// getFCMToken()
	}, [])

	const [containerHeight, setContainerHeight] = useState(window.innerHeight);
	useEffect(() => {
		const handleResize = () => {
			setContainerHeight(window.innerHeight);
		};

		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	const getFCMToken = () => {
		Notification.requestPermission().then((permission) => {
			if (permission === "granted") {
				console.log("Notification permission granted.");
				requestForToken()
					.then((currentToken) => {
						if (currentToken) {
							setToken(currentToken);
						} else {
							console.log(
								"No registration token available. Request permission to generate one."
							);
						}
					})
					.catch((err) => {
						console.log("An error occurred while retrieving token. ", err);
					});
			} else {
				console.log("Unable to get permission to notify.");
				toast.warning("Please allow notifications to receive updates.");
			}
		});
	};

	const handleEmailChange = (e) => {
		setEmail(e.target.value);
		setEmailError(""); // Clear email error when user types
	};

	const handlePasswordChange = (e) => {
		setPassword(e.target.value);
		setPasswordError(""); // Clear password error when user types
	};

	const validateFields = () => {
		let isValid = true;

		// Email validation
		if (!email) {
			setEmailError("Email is required");
			isValid = false;
		} else if (!/\S+@\S+\.\S+/.test(email)) {
			console.log("Invalid email format");
			setEmailError("Please enter a valid email address");
			isValid = false;
		}

		// Password validation
		if (!password) {
			setPasswordError("Password is required");
			isValid = false;
		}

		return isValid;
	};

	// const pharmacyLogin = async (e) => {
	// 	e.preventDefault();
	// 	if (validateFields()) {
	// 		const body = {
	// 			email: email.toLowerCase(),
	// 			password: password,
	// 			role: "pharmacy"
	// 		}
	// 		try {
	// 			setLoading(true);
	// 			// const response = await axiosInstance.post('superadmin/login', body)
	// 			// const response = await axiosNAKBHOInstance.post('healthcare_providers/auth/login', body)
	// 			// healthcare_providers/auth/login is previous api
	// 			const response = await axiosInstance.post('healthcare_providers/auth/login', body)
	// 			// below new api is updated for standalone pharmacy login
	// 			// const response = await axiosInstance.post('pharmacyUser/login', body)
	// 			// if(response.data.response === "success") {
	// 			if (response.data.status === "success") {
	// 				// localStorage.setItem('currentPharmacyPOS', JSON.stringify(response.data.data.user));
	// 				// nakhbo api change
	// 				// localStorage.setItem('currentPharmacyPOS', JSON.stringify(response.data.data.healthcare_provider));
	// 				// standalone pharmacy change
	// 				// =================
	// 				// localStorage.setItem('currentPharmacyPOS', JSON.stringify(response.data.data.healthCareProvider));
	// 				// localStorage.setItem('pharmacyPOSAuth', response.data.data.token);
	// 				// setPharmacyPOS(response.data.data.healthCareProvider);
	// 				// // setPharmacyPOS(response.data.data.healthcare_provider);
	// 				// history(`${process.env.PUBLIC_URL}/dashboard`);
	// 				const pharmacy = response.data.data.healthCareProvider;
	// 				const authToken = response.data.data.token;
	// 				const serverLicenseToken = pharmacy.licenseToken;

	// 				// 1️⃣ Save auth + user
	// 				localStorage.setItem(
	// 					'currentPharmacyPOS',
	// 					JSON.stringify(pharmacy)
	// 				);
	// 				localStorage.setItem('pharmacyPOSAuth', authToken);
	// 				setPharmacyPOS(pharmacy);

	// 				const pharmacyId = pharmacy._id;

	// 				// 2️⃣ Check existing license (if any)
	// 				const existingDecoded = await decodeTokenOnly();
	// 				const belongs = existingDecoded &&
	// 					doesLicenseBelongToUser(existingDecoded, pharmacyId);

	// 				// 3️⃣ If license exists & belongs to user
	// 				if (
	// 					existingDecoded &&
	// 					doesLicenseBelongToUser(existingDecoded, pharmacyId)
	// 				) {
	// 					// Refresh license token from server (important!)
	// 					if (serverLicenseToken) {
	// 						await saveLicenseToken(serverLicenseToken);
	// 					}

	// 					// Let LicenseContext validate → route guard decides
	// 					history(`${process.env.PUBLIC_URL}/dashboard`, { replace: true });
	// 					return;
	// 				}

	// 				// 4️⃣ No valid matching license → save token & activate
	// 				if (serverLicenseToken) {
	// 					await saveLicenseToken(serverLicenseToken);
	// 				}

	// 				history(`${process.env.PUBLIC_URL}/activate`, { replace: true });
	// 			}
	// 		} catch (error) {
	// 			console.error('Error fetching data:', error);
	// 		} finally {
	// 			setLoading(false);
	// 		}
	// 	}
	// }

	const handleLoginClick = async (e) => {
		e.preventDefault();
		if (!validateFields()) return;

		const result = await Swal.fire({
			title: t("Sign in on this device?"),
			text: t("Your current session on another device or browser will be signed out."),
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: t("Continue here"),
			cancelButtonText: t("Cancel"),
			reverseButtons: true,
			customClass: {
				confirmButton: "btn-primary",
				cancelButton: "btn-secondary",
			},
		});

		if (result.isConfirmed) {
			await pharmacyLogin();
		}
	};

	const pharmacyLogin = async () => {
		const body = {
				email: email.toLowerCase(),
				password: password,
				role: "pharmacy"
			}
			try {
				setLoading(true);
				const response = await axiosInstance.post('healthcare_providers/auth/login', body)

				if (response.data.status === "success") {
					const pharmacy = response.data.data.healthCareProvider;
					const authToken = response.data.data.token;
					const serverLicenseToken = pharmacy.licenseToken;

					// 1️⃣ Save auth + user
					localStorage.setItem(
						'currentPharmacyPOS',
						JSON.stringify(pharmacy)
					);
					localStorage.setItem('pharmacyPOSAuth', authToken);
					setPharmacyPOS(pharmacy);

					const pharmacyId = pharmacy._id;

					// // 2️⃣ Save server license token FIRST (if exists)
					// if (serverLicenseToken) {
					// 	await saveLicenseToken(serverLicenseToken);
					// }

					// // 3️⃣ NOW check if license belongs to user
					// const existingDecoded = await decodeTokenOnly();
					// // const existingDecoded = await decodeJWT(serverLicenseToken);

					// // 4️⃣ If license exists & belongs to user
					// if (
					// 	existingDecoded &&
					// 	doesLicenseBelongToUser(existingDecoded, pharmacyId)
					// ) {
					// 	// License is valid and belongs to user
					// 	toast.success('Login successful!');
					// 	history(`${process.env.PUBLIC_URL}/dashboard`, { replace: true });
					// 	return;
					// }

					// // 5️⃣ No valid license or doesn't belong to user
					// if (!existingDecoded) {
					// 	// No license token exists
					// 	toast.info('Please activate your license');
					// 	history(`${process.env.PUBLIC_URL}/activate`, { replace: true });
					// 	return;
					// }

					if (serverLicenseToken) {
						await saveLicenseToken(serverLicenseToken);
						const decoded = await decodeJWT(serverLicenseToken);
						// console.log(decoded)
						const isAllowedUser = decoded?.users?.some(
							(user) => user.id === pharmacyId
						);

						if (isAllowedUser) {
							history(`${process.env.PUBLIC_URL}/dashboard`, { replace: true });
							return;
						} else {
							toast.warning('User is not registered with us. Please contact the ClinicDots admin.');
							history(`${process.env.PUBLIC_URL}/login`, { replace: true });
							localStorage.clear();
						}
					} else {
						history(`${process.env.PUBLIC_URL}/activate`, { replace: true });
					}

					// by pass license check for now
					// history(`${process.env.PUBLIC_URL}/dashboard`, { replace: true });

				} else {
					toast.warning('Login failed. Please try again.');
				}
			} catch (error) {
				console.error('Error fetching data:', error);
				// toast.warning(error.response?.data?.message || 'Login failed');
			} finally {
				setLoading(false);
			}
	}

	const loginAuth = async (e) => {
		e.preventDefault();
		if (validateFields()) {
			const body = {
				email: email.toLowerCase(),
				password: password,
				device_info: {
					platform: 'web',
					token: token,
					device_id: '',
				}
			}
			try {
				setLoading(true);
				// const response = await axiosInstance.post('clinic_admin/auth/login', body)
				const response = await secureApiRequest("post", 'clinic_admin/auth/login', body)
				const dec_data = decryptResponseData(response);
				// dec_data = response.data;
				// if (response.data.data.clinic_admin.role === 'clinic_admin') {
				if (dec_data.data.clinic_admin) {
					localStorage.setItem('hospitalAdminAuth', dec_data.data.token)
					localStorage.setItem('currentHospitalAdmin', JSON.stringify(dec_data.data.clinic_admin))
					setClinicAdmin(dec_data.data.clinic_admin);
					// setUserPrivileges(dec_data.data.clinic_admin.privileges_profiles : null)
					if (dec_data.data.clinic_admin.role === 'clinic_admin') {
						setUserPrivileges(null)
					} else {
						setUserPrivileges(dec_data.data.clinic_admin.privileges_profiles || null);
					}
					if (dec_data.data.clinic_admin.role === "clinic_admin" && dec_data.data.clinic_admin.currency === false) {
						history(`${process.env.PUBLIC_URL}/clinic_admin_settings`);
					} else {
						history(`${process.env.PUBLIC_URL}/dashboard`);
					}
				}
			} catch (error) {
				console.error('Error fetching data:', error);
			}
			finally {
				setLoading(false);
			}
		}
	};

	const forgotPassword = () => {
		history(`${process.env.PUBLIC_URL}/forgot-password`);
	};

	return (
		<Fragment>
			<div className="login-page">
				<Container fluid={false} style={{ paddingTop: '1rem', paddingBottom: '0.5rem' }}>
					<div className="card">
						<Row className="m-0">
							<Col
								xs="6"
								className="b-center bg-size d-none d-md-flex flex-column"
								style={{
									backgroundImage: `url(${require('../assets/images/login/login_left_img.png')})`,
									backgroundSize: 'cover',
									backgroundPosition: 'center',
									// borderTopLeftRadius: '15px',
									// borderBottomLeftRadius: '15px',
									// padding: '20px',
									color: '#1B245B', // Ensures text is white on the dark background
								}}
							>
								<div style={{ marginLeft: "10%" }}>
									<Image
										attrImage={{
											className: 'login-logo-style',
											src: `${logoDark}`,
											alt: 'CLINICDOTS Logo',
										}}
									/>
									<h3 style={{ fontWeight: 'bold', marginBottom: '0px', letterSpacing: '2px' }}>CLINICDOTS</h3>
									<h3 style={{ fontWeight: 'bold', marginBottom: '20px', letterSpacing: '3px' }}>PHARMACY</h3>
									<span>{t("Innovating Healthcare for India.")}</span>
								</div>
							</Col>

							<Col xs="12" md="6"
								style={{
									backgroundImage: `url(${require('../assets/images/login/login_right_img.png')})`,
									backgroundSize: 'cover',
									backgroundPosition: 'center',
									// borderTopLeftRadius: '15px',
									// borderBottomLeftRadius: '15px',
									minHeight: `${containerHeight * 0.94}px`,
									display: 'flex',
									flexDirection: 'column'
								}}>
								<div className='login-card' style={{ flex: '1' }}>
									<div className="login-form-responsive">
										<Form className="theme-form login-form">
											{/* This image will only be visible on mobile screens */}
											<Image
												attrImage={{
													className: 'login-dark-logo-style d-block d-md-none',
													src: `${logoDark}`,
													alt: 'CLINICDOTS Logo',
												}}
											/>
											<H4><strong className="mb-3">{t("Login")} - {t("Pharmacy")}</strong></H4>
											<P>{t("Welcome to")} <strong>CLINICDOTS</strong> {t("Pharmacy")}</P>

											<FormGroup className="position-relative">
												<Label className="col-form-label">{t("Email")}</Label>
												<div className="position-relative">
													<i className="fa fa-envelope-o position-absolute" style={{ left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#000', fontSize: "large" }}></i>
													<Input
														className="form-control pl-5"
														type="email"
														placeholder={t("Enter email")}
														onChange={handleEmailChange}
														value={email}
														style={{ paddingLeft: '40px' }}
													/>
												</div>
												{emailError && <div className="text-danger">{emailError}</div>}
											</FormGroup>

											<FormGroup className="position-relative">
												<Label className="col-form-label">{t(Password)}</Label>
												<div className="position-relative">
													<i className="fa fa-lock position-absolute"
														style={{
															left: '10px',
															top: '50%',
															transform: 'translateY(-50%)',
															color: '#000',
															fontSize: "x-large"
														}}></i>
													<Input
														className="form-control pl-4"
														type={togglePassword ? "text" : "password"}
														placeholder={t("Enter password")}
														onChange={handlePasswordChange}
														value={password}
														style={{ paddingLeft: '40px' }}
													/>
													<div
														className="position-absolute"
														style={{
															right: '10px',
															top: '50%',
															transform: 'translateY(-50%)',
															cursor: 'pointer',
															color: '#000',
															fontSize: "x-large"
														}}
														onClick={() => setTogglePassword(!togglePassword)}
													>
														<i className={`fa ${togglePassword ? 'fa-eye-slash' : 'fa-eye'}`} aria-hidden="true"></i>
													</div>
												</div>
												{passwordError && <div className="text-danger">{passwordError}</div>}
											</FormGroup>

											<p style={{ textAlign: "end" }}><strong style={{ cursor: "pointer" }} onClick={forgotPassword}>{t("Forgot Password ?")}</strong></p>
											<div className="position-relative form-group mb-0">
												<Btn attrBtn={{ type: "submit", color: "primary", className: "d-block w-100 login-button", onClick: handleLoginClick }}>{t("Login")}</Btn>
											</div>
										</Form>
									</div>
								</div>
								<div className="mx-3" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
									<small className="my-3">
										{t("All rights reserved Copyright ©")} {new Date().getFullYear()} {t("CLINICDOTS HEALTHCARE.")}
									</small>
									{/* <div style={{ display: 'flex', gap: '10px' }}>
									<Image
										attrImage={{
											className: 'mb-4 login-footer-logo',
											src: `${assets5}`,
											alt: 'Assets 5 Logo',
										}}
									/>
									<Image
										attrImage={{
											className: 'mb-4 login-footer-logo',
											src: `${coatOfArms}`,
											alt: 'Coat Of Arms Logo',
										}}
									/>
								</div> */}
								</div>
							</Col>
						</Row>
					</div>
				</Container>
			</div>
			<ToastContainer />
		</Fragment>
	);
};

export default Signin;
